// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__21-Qq","empty":"ModalGraph_empty__1knhR"};